import { useApiClient } from "@/composables/useApiClient";
import { SchoolClassTypeEnum } from "@/services/fobizzToolsApi";
import { getMe as fetchUser } from "@/services/orval/internalApiV1";
import { isVisitor, isPupil } from "@/stores/user";

export const useSession = () => {
  const { sessions: sessionsService } = useApiClient();

  const userStore = useUserStore();
  const incognitoStore = useIncognitoStore();

  const queryClient = inject("queryClient") as ReturnType<
    typeof useQueryClient
  >;

  const refetchUser = async () => {
    try {
      const newUser = await fetchUser();

      // replace user with fresh data to ensure that any stale data is removed
      // => https://pinia.vuejs.org/core-concepts/state.html#Replacing-the-state
      userStore.$state = {
        ...userStore.$state,
        user: newUser,
      };

      if (isVisitor(newUser)) {
        userStore.visitorToken = newUser.toolsUserId;
      } else {
        userStore.visitorToken = undefined;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const router = useRouter();

  const logout = async (redirectBack: false | string = false) => {
    try {
      const pupil = userStore.isPupil;
      let isOneTime = false;
      if (isPupil(userStore.user)) {
        isOneTime =
          userStore.user?.schoolClassType === SchoolClassTypeEnum.ONETIME;
      }

      await sessionsService.deleteSession();

      userStore.reset();
      incognitoStore.$reset();

      queryClient.clear();

      await refetchUser();

      if (!redirectBack) {
        if (pupil) {
          if (isOneTime) {
            router.push({ name: "pupil-logout-success" });
          } else {
            router.push({ name: "go-login" });
          }
        } else {
          router.push({ name: "home" });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  return {
    logout,
    refetchUser,
  };
};
